const prodConfigs = {
    // 本地
    'localhost': {
        apiHost: '/api',
        domain: 'http://sdk1.dev.hodogame.com',
        staticHost: '',
        vconsole: false
    },
    '192.168.11.48': {
        apiHost: '/api',
        domain: 'http://sdk1.dev.hodogame.com',
        staticHost: '',
        vconsole: true
    },
    // 开发环境
    'sdk1.dev.hodogame.com': {
        apiHost: 'http://sdk-server1.dev.hodogame.com',
        domain: 'http://sdk1.dev.hodogame.com',
        staticHost: '',
        vconsole: true
    },
    // 测试环境
    'sdk1.test.hodogame.com': {
        apiHost: 'http://sdk-server1.test.hodogame.com',
        domain: 'http://sdk1.test.hodogame.com',
        staticHost: '',
        vconsole: true
    },
    'sdk2.test.hodogame.com': {
        apiHost: 'http://sdk-server2.test.hodogame.com',
        domain: 'http://sdk2.test.hodogame.com',
        staticHost: '',
        vconsole: true
    },
    'sdk3.test.hodogame.com': {
        apiHost: 'http://sdk-server3.test.hodogame.com',
        domain: 'http://sdk3.test.hodogame.com',
        staticHost: '',
        vconsole: true
    },
    // 预发环境
    'sdk-pre.hodogame.com': {
        apiHost: 'http://sdk-s-pre.hodogame.com',
        domain: 'http://sdk-pre.hodogame.com',
        staticHost: '',
        vconsole: true
    },
    'eusdk-pre.yunmfyl.cn': {
        apiHost: 'http://eusdk-s-pre.yunmfyl.cn',
        domain: 'http://eusdk-pre.yunmfyl.cn',
        staticHost: '',
        vconsole: true
    },
    // 正式环境
    'sdk.hodogame.com': {
        apiHost: 'http://sdk-s.hodogame.com',
        domain: 'http://sdk.hodogame.com',
        staticHost: '',
        vconsole: false
    },
    'eu-sdk.dck5.com': {
        apiHost: 'http://eu-sdk-s.dck5.com',
        domain: 'http://eu-sdk.dck5.com',
        staticHost: '',
        vconsole: false
    },
    'eusdk.yunmfyl.cn': {
        apiHost: 'http://eusdk-s.yunmfyl.cn',
        domain: 'http://eusdk.yunmfyl.cn',
        staticHost: '',
        vconsole: false
    }
    // 'eusdk.tssdk.com': {
    //     apiHost: 'http://eusdk-s.tssdk.com',
    //     domain: 'http://eusdk.tssdk.com',
    //     staticHost: '',
    //     vconsole: true
    // }
}
const defaultConfig = {
    apiHost: 'http://sdk-s.hodogame.com',
    domain: 'http://sdk.hodogame.com',
    staticHost: '',
    vconsole: false
}

const hostConfig = prodConfigs[location.hostname] || defaultConfig
export default hostConfig
